export default __webpack_public_path__ + "static/babel-logo-37377d79d8010eb5e2051b1b37d782c7.svg";